import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select from "react-select"
import { ValueType } from "react-select/lib/types"
import swal from "sweetalert"
import { useAppDispatch } from "../../app/hooks"
import { addParcel } from "../../store/parcel.store"

const AddParcelModal = ({
    show,
    handleClose,
    customers
}: {
    show: string
    handleClose: () => void
    customers: any
}) => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [showError, setShowError] = useState<boolean>(false)
    const [disableAddParcel, setDisableAddParcel] = useState<boolean>(false)

    const dispatch = useAppDispatch()
    const [parcelDetails, setParcelDetails] = useState({
        awb: "",
        userPin: "",
        canConsolidate: true
    })
    const checkAllRequiredFields = () => {
        if (
            parcelDetails.awb &&
            parcelDetails.awb !== "" &&
            parcelDetails.userPin &&
            parcelDetails.userPin !== ""
        ) {
            setDisableAddParcel(false)
        } else {
            setDisableAddParcel(true)
        }
    }

    useEffect(() => {
        checkAllRequiredFields()
    }, [parcelDetails.awb, parcelDetails.userPin, parcelDetails.canConsolidate])

    const addParcelDetail = async (edit: boolean) => {
        var data: any = {
            awb: parcelDetails.awb,
            user_pin: parcelDetails.userPin,
            can_consolidate: parcelDetails.canConsolidate
        }
        var purchased: any = await dispatch(addParcel(data))
        if (purchased?.payload?.data && purchased?.payload?.data?.status === true) {
            setLoading(false)
            swal({
                title: "",
                text: t("Parcel_is_created"),
                icon: "success"
            }).then(function () {
                handleClose()
            })
        } else {
            setLoading(false)
            swal({
                title: "",
                text: t("Parcel_is_not_created"),
                icon: "error"
            }).then(function () {})
        }
    }
    const handleCreateParcel = async (e: any) => {
        setLoading(true)
        addParcelDetail(true)
    }
    const handleSaveParcel = async (e: any) => {
        setLoading(true)
        addParcelDetail(false)
    }

    const handleChange = (option: ValueType<any>) => {
        setParcelDetails({ ...parcelDetails, userPin: option?.value })
    }
    return (
        <Modal
            show={show === "receiveParcel"}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("Create_New_Parcel")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>{t("Create_parcel_description")}</div>
                <Form noValidate className="form">
                    <Form.Group className="mt-2" controlId="customer">
                        <Form.Label column md="4" sm="2">
                            {t("Select Customer")}
                        </Form.Label>

                        <Select
                            options={customers}
                            name="userPin"
                            placeholder={t("Select_User")}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group className="mt-2" controlId="awb">
                        <Form.Label column md="4" sm="2">
                            {t("Enter AWB")}
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("AWB")}
                            name="awb"
                            required={true}
                            onChange={(e: any) =>
                                setParcelDetails({ ...parcelDetails, [e.target.name]: e.target.value })
                            }
                        />
                    </Form.Group>
                    <Form.Group className="mt-2" controlId="can_consolidate">
                        <Form.Check
                            type="checkbox"
                            name="canConsolidate"
                            label={t("Not eligible for consolidation")}
                            onChange={(e: any) =>
                                setParcelDetails({ ...parcelDetails, [e.target.name]: e.target.checked })
                            }
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" type="submit" onClick={handleSaveParcel}>
                    {t("Save")}
                </Button>
                <Button
                    disabled={loading || disableAddParcel}
                    id="btn-primary"
                    className="btn btn-primary"
                    type="submit"
                    onClick={handleCreateParcel}>
                    {" "}
                    {loading ? (
                        <div className="spinner-border text-light" role="status"></div>
                    ) : (
                        t("Add_Parcel_Details")
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddParcelModal
